/* Bundle Deals (v2) — externalized from snippets/bundle-deals.liquid (logic
   unchanged). Liquid-interpolated data (labels, ordinals, money sample, size
   rules/tips) comes from the JSON config block
   <script type="application/json" data-bd-config> rendered next to the picker. */
(function () {
  if (window.__sneakBundleDealsLoaded) return;
  window.__sneakBundleDealsLoaded = true;

  function init() {
    var wrap = document.querySelector('[data-bundle-deals]');
    if (!wrap || wrap.dataset.bdReady) return;
    wrap.dataset.bdReady = '1';

    var cfgEl = document.querySelector('[data-bd-config]');
    var cfg = {};
    try { if (cfgEl) cfg = JSON.parse(cfgEl.textContent) || {}; } catch (e) {}

    var deals = Array.prototype.slice.call(wrap.querySelectorAll('[data-bd-deal]'));
    var groupBlocks = Array.prototype.slice.call(wrap.querySelectorAll('[data-bd-groupblock]'));
    var summaryEl = wrap.querySelector('[data-bd-summary]');
    var ctaBtn = wrap.querySelector('[data-bd-cta]');
    var ctaLabel = wrap.querySelector('[data-bd-cta-label]');
    var ctaPrice = wrap.querySelector('[data-bd-cta-price]');
    var ctaCompare = wrap.querySelector('[data-bd-cta-compare]');
    var upsellBtn = wrap.querySelector('[data-bd-upsell]');
    var upsellText = wrap.querySelector('[data-bd-upsell-text]');

    var L = cfg.labels || {};
    /* Swedish article: en (default) vs ett (neuter garments like "par"). */
    var ARTICLE = cfg.article;
    var ARTICLE_ETT = cfg.articleEtt;
    var ETT_GARMENTS = (cfg.ettGarments || '').toLowerCase().split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    var ORDINALS = cfg.ordinals || {};
    /* Plural ordinals for plural-only garments (FI "kolmannet shortsit"). */
    var ORDINALS_PL = cfg.ordinalsPl || {};
    var PLURAL_GARMENTS = (cfg.pluralGarments || '').toLowerCase().split(',').map(function (w) { return w.trim(); }).filter(Boolean);
    function pickText(n) { return L.pick.replace('%', n); }
    /* Currency-aware: derive the symbol/placement from the theme's own money
       filter so JS-computed prices use the store currency (kr on SE, € on FI). */
    var _mSample = cfg.moneySample;
    var _mFirst = _mSample.search(/\d/);
    var _mRev = _mSample.split('').reverse().join('').search(/\d/);
    var MONEY_PREFIX = _mFirst < 0 ? '' : _mSample.slice(0, _mFirst);
    /* Fallback derives from the store, never a hardcoded symbol — a wrong
       currency is worse than an ugly one. Unreachable unless the money filter
       emits no digits at all. */
    var MONEY_SUFFIX = _mRev < 0 ? ' ' + cfg.shopCurrency : _mSample.slice(_mSample.length - _mRev);
    function money(c) { return MONEY_PREFIX + (c / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + MONEY_SUFFIX; }

    var L48 = cfg.l48;
    var perUnitLabel = cfg.perUnit;
    var BADGE = cfg.badge || {};
    function badgeHtml(is48) {
      return is48
        ? '<span class="badge badge--48h"><svg class="badge-48h-icon" aria-hidden="true"><use xlink:href="#48h-icon-badge"></use></svg>' + BADGE.e48 + '</span>'
        : '<span class="badge badge--preorder">' + BADGE.pre + '</span>';
    }

    /* group blocks keyed by id; gather product unit prices for savings calc */
    var blocks = {};
    groupBlocks.forEach(function (gb) {
      var id = gb.dataset.bdGroup;
      blocks[id] = {
        el: gb,
        cards: Array.prototype.slice.call(gb.querySelectorAll('[data-bd-card]')),
        built: {}, /* lazily-built size groups, keyed by product name */
        panel: gb.querySelector('[data-bd-panel]'),
        panelName: gb.querySelector('[data-bd-panel-name]'),
        pill: gb.querySelector('[data-bd-pill]'),
        label: gb.dataset.bdLabel || '',
        strip: (gb.dataset.bdStrip || '').split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean),
        unit: 0,
        unitCompare: 0,
        img: {}
      };
      /* image per product name, for the summary chips */
      blocks[id].cards.forEach(function (c) {
        var im = c.querySelector('img');
        blocks[id].img[c.dataset.bdName] = im ? im.src : '';
      });
      /* representative unit = min product price; savings always use the
         HIGHEST compare-at in the group (products share an RRP, but some
         rows have a lower/missing compare-at — normalise to the max). */
      blocks[id].cards.forEach(function (c) {
        var p = parseInt(c.dataset.bdPrice, 10) || 0;
        if (p > 0 && (blocks[id].unit === 0 || p < blocks[id].unit)) blocks[id].unit = p;
        var cmp = parseInt(c.dataset.bdCompare, 10) || 0;
        if (cmp > blocks[id].unitCompare) blocks[id].unitCompare = cmp;
      });
    });

    /* Strip the shared title prefix (e.g. "Fear of God Essentials T-shirt")
       from each group's product names so colours read cleanly. */
    function commonPrefixWords(names) {
      if (names.length < 2) return [];
      var split = names.map(function (n) { return n.split(' '); });
      var prefix = [];
      for (var i = 0; i < split[0].length; i++) {
        var w = split[0][i];
        var all = split.every(function (s) { return s[i] && s[i].toLowerCase() === w.toLowerCase(); });
        if (!all) break;
        prefix.push(w);
      }
      while (prefix.length && split.some(function (s) { return s.length <= prefix.length; })) prefix.pop();
      return prefix;
    }
    // Garment/fit words that are noise in a colour name — always stripped so
    // pants/shorts read cleanly (e.g. "Relaxed Sweatpants Light Oatmeal" →
    // "Light Oatmeal"). Kept conservative to avoid eating colours/collabs.
    var GARMENT_WORDS = ['sweatpants', 'sweatpant', 'sweatshorts', 'sweatshort'];
    Object.keys(blocks).forEach(function (gid) {
      var b = blocks[gid];
      var prefix = commonPrefixWords(b.cards.map(function (c) { return c.dataset.bdName; }));
      var labelWords = (b.label || '').toLowerCase().split(' ').filter(Boolean);
      // Multi-word strip entries (e.g. "a bathing ape") are removed as a whole
      // phrase; single words are filtered token-by-token.
      var phrases = (b.strip || []).filter(function (t) { return t.indexOf(' ') !== -1; });
      var singleWords = labelWords
        .concat((b.strip || []).filter(function (t) { return t.indexOf(' ') === -1; }))
        .concat(GARMENT_WORDS);
      b.shorten = function (name) {
        var w = name.split(' ');
        var s = ((prefix.length && w.length > prefix.length) ? w.slice(prefix.length) : w).join(' ');
        phrases.forEach(function (term) {
          var esc = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          s = s.replace(new RegExp('\\b' + esc + '\\b', 'ig'), ' ');
        });
        var out = s.split(/\s+/).filter(Boolean).filter(function (word) {
          return singleWords.indexOf(word.toLowerCase()) === -1;
        }).join(' ').trim();
        return out || name;
      };
      b.cards.forEach(function (c) {
        var el = c.querySelector('.bundle-tiers__color-name');
        if (el) el.textContent = b.shorten(c.dataset.bdName);
      });
    });

    /* Put the product you're viewing first in its group's row. */
    var currentHandle = wrap.dataset.currentHandle;
    if (currentHandle) {
      // Colour of the product you're viewing (e.g. "Coral"), to match across groups.
      var currentColor = '';
      Object.keys(blocks).forEach(function (gid) {
        var cur = blocks[gid].cards.filter(function (c) { return c.dataset.bdHandle === currentHandle; })[0];
        if (cur) currentColor = blocks[gid].shorten(cur.dataset.bdName).toLowerCase();
      });
      Object.keys(blocks).forEach(function (gid) {
        var b = blocks[gid];
        var row = b.el.querySelector('[data-bd-colors]');
        // Current product first; in other groups, surface the same colour first
        // (e.g. on Coral shorts, show the Coral tee first).
        var match = b.cards.filter(function (c) { return c.dataset.bdHandle === currentHandle; })[0];
        if (!match && currentColor) {
          match = b.cards.filter(function (c) { return b.shorten(c.dataset.bdName).toLowerCase() === currentColor; })[0];
        }
        if (match && row && row.firstChild !== match) {
          row.insertBefore(match, row.firstChild);
          b.cards = [match].concat(b.cards.filter(function (c) { return c !== match; }));
        }
        if (row) row.scrollLeft = 0;
      });
    }

    /* Per-group fit tip (same rules the product page uses). */
    var SIZE_RULES = cfg.sizeRules;
    var SIZE_TIPS = cfg.sizeTips || {};
    function sizeTipFor(title) {
      if (!SIZE_RULES) return '';
      title = (title || '').toLowerCase();
      var entries = Object.entries(SIZE_RULES);
      for (var i = 0; i < entries.length; i++) {
        var keywords = entries[i][0].split(',');
        var tipKey = entries[i][1];
        var allMatch = keywords.every(function (kw) {
          var t = kw.trim().toLowerCase();
          if (t.charAt(0) === '!') return title.indexOf(t.slice(1)) === -1;
          return title.indexOf(t) !== -1;
        });
        if (allMatch && SIZE_TIPS[tipKey]) return SIZE_TIPS[tipKey];
      }
      return '';
    }
    var bdSizeChart = document.querySelector('[id^="size-chart-overlay-"]');
    function openSizeChart(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      var d = document.querySelector('[id^="size-chart-overlay-"]');
      if (!d) return;
      if (d.show) d.show(); else d.setAttribute('open', '');
    }
    groupBlocks.forEach(function (gb) {
      var card = gb.querySelector('[data-bd-card]');
      var el = gb.querySelector('[data-bd-sizetip]');
      var txt = gb.querySelector('[data-bd-sizetip-text]');
      if (!card || !el || !txt) return;
      var tip = sizeTipFor(card.dataset.bdName);
      if (tip) {
        txt.textContent = tip; el.title = tip; el.hidden = false;
        if (bdSizeChart) {
          el.classList.add('is-clickable');
          el.addEventListener('click', openSizeChart);
        }
      }
    });

    /* Desktop scroll arrows + edge fades, per group row. */
    function updateScrollers() {
      Array.prototype.slice.call(wrap.querySelectorAll('[data-bd-scroller]')).forEach(function (sc) {
        var row = sc.querySelector('[data-bd-colors]');
        if (!row) return;
        var atStart = row.scrollLeft <= 1;
        var atEnd = row.scrollLeft + row.clientWidth >= row.scrollWidth - 1;
        sc.toggleAttribute('data-at-start', atStart);
        sc.toggleAttribute('data-at-end', atEnd);
      });
    }
    Array.prototype.slice.call(wrap.querySelectorAll('[data-bd-scroller]')).forEach(function (sc) {
      var row = sc.querySelector('[data-bd-colors]');
      if (!row) return;
      row.addEventListener('scroll', updateScrollers, { passive: true });
      sc.querySelectorAll('[data-bd-arrow]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = parseInt(btn.dataset.bdArrow, 10) || 1;
          row.scrollBy({ left: dir * Math.round(row.clientWidth * 0.8), behavior: 'smooth' });
        });
      });
    });
    window.addEventListener('resize', updateScrollers);

    /* precompute each deal's "regular" total for the SAVE badge on the card */
    deals.forEach(function (d) {
      var items = JSON.parse(d.dataset.bdItems || '[]');
      var regular = 0;
      items.forEach(function (it) { regular += (blocks[it.group] ? blocks[it.group].unitCompare : 0) * it.qty; });
      var price = parseInt(d.dataset.bdPrice, 10) || 0;
      var save = regular - price;
      var saveEl = d.querySelector('[data-bd-save]');
      if (saveEl && save > 0) { saveEl.textContent = L.save.replace('#A#', money(save)); saveEl.hidden = false; }
      var cmpEl = d.querySelector('[data-bd-compare-total]');
      if (cmpEl && regular > price) { cmpEl.textContent = money(regular); cmpEl.hidden = false; }
    });

    /* Set cards: one thumbnail per group the deal includes. Runs after the
       "current product first" reorder above, so cards[0] is the product being
       viewed in its own group — the set pictures the tee you're looking at. */
    deals.forEach(function (d) {
      var holder = d.querySelector('[data-bd-thumbs]');
      if (!holder) return;
      JSON.parse(d.dataset.bdItems || '[]').forEach(function (it) {
        var b = blocks[it.group];
        var im = b && b.cards[0] && b.cards[0].querySelector('img');
        if (!im) return;
        var t = document.createElement('img');
        t.src = im.src; t.alt = ''; t.width = 32; t.height = 32; t.loading = 'lazy';
        holder.appendChild(t);
      });
    });

    /* state */
    var deal = null;            /* { index, items:[{group,qty}], price, priceFmt } */
    var need = {};              /* groupId -> required count */
    var sel = {};               /* groupId -> [{id,name,size,qty,e48}] */
    var upsold = false;         /* true once the shopper accepted the tier upsell */
    var step1Num = wrap.querySelector('.bundle-tiers__step:not([data-bd-groupblock]) .bundle-tiers__step-num');

    function groupCount(gid) { return (sel[gid] || []).reduce(function (n, s) { return n + s.qty; }, 0); }
    function findSel(gid, id) { var a = sel[gid] || []; for (var i = 0; i < a.length; i++) if (a[i].id === id) return a[i]; return null; }
    function allFull() { return Object.keys(need).every(function (g) { return groupCount(g) >= need[g]; }); }

    /* A group whose only card is a single-variant product (one booster, no
       sizes) has nothing to choose: its card, or null when there is a choice.
       A row still waiting to top itself up may hold more, so it doesn't count. */
    function soleCard(gid) {
      var b = blocks[gid];
      if (!b || b.cards.length !== 1 || b.el.dataset.bdMoreUrl) return null;
      return b.cards[0].dataset.bdSingle ? b.cards[0] : null;
    }

    function escAttr(s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;'); }
    function escHtml(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

    /* Build one product's size buttons on demand from /products/{handle}.js
       (shows "…" immediately, fills when the fetch resolves). Cached per name. */
    function buildSizeGroup(b, name, done) {
      if (b.built[name]) { done(b.built[name]); return; }
      var card = b.cards.filter(function (c) { return c.dataset.bdName === name; })[0];
      if (!card) { done(null); return; }
      var sg = document.createElement('div');
      sg.className = 'bundle-tiers__sizes';
      sg.setAttribute('data-bd-sizegroup', '');
      sg.dataset.bdName = name;
      sg.dataset.bdPrice = card.dataset.bdPrice || '';
      sg.dataset.bdCompare = card.dataset.bdCompare || '';
      sg.hidden = true;
      sg.innerHTML = '<span class="bundle-tiers__sizes-loading">…</span>';
      b.panel.appendChild(sg);
      b.built[name] = sg;
      done(sg);
      fetch('/products/' + card.dataset.bdHandle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          /* /products/{handle}.js hides inventory_quantity, so the in-stock (48h)
             vs oversold (preorder/incoming) split comes from Liquid on the card.
             `available` still drives the disabled/sold-out state. */
          var instockIds = (card.dataset.bdInstockIds || '').split(',').filter(Boolean);
          var incoming = card.dataset.bdIncoming === '1';
          var backorderIds = (card.dataset.bdBackorderIds || '').split(',').filter(Boolean);
          var html = '';
          (p.variants || []).forEach(function (v) {
            var purchasable = v.available;
            var inStock = instockIds.indexOf(String(v.id)) !== -1;
            var badge = '';
            if (inStock) {
              badge = '<span class="bundle-tiers__size-badge bundle-tiers__size-badge--48h" title="' + escAttr(L48) + '"><svg class="icon" width="11" height="11"><use xlink:href="#48h-icon"></use></svg></span>';
            } else if (purchasable && backorderIds.indexOf(String(v.id)) !== -1) {
              /* Ships in about a week (custom.backorder_days) */
              badge = '<span class="incoming backorder-week"><svg class="icon" width="11" height="11"><use xlink:href="#backorder-icon"></use></svg></span>';
            } else if (purchasable && incoming) {
              badge = '<span class="incoming"><svg class="icon" width="11" height="11"><use xlink:href="#incoming-icon"></use></svg></span>';
            }
            html += '<button type="button" class="block-swatch bundle-tiers__size' + (purchasable ? '' : ' is-disabled') + '"'
              + ' data-bd-size data-bd-id="' + v.id + '" data-bd-size-label="' + escAttr(v.title) + '"'
              + ' data-bd-instock="' + (inStock ? '1' : '') + '"' + (purchasable ? '' : ' disabled') + '>'
              + badge
              + '<span class="variant-info"><span class="variant-label">' + escHtml(v.title) + '</span></span>'
              + '<span class="bundle-tiers__size-count" data-bd-count></span>'
              + '</button>';
          });
          sg.innerHTML = html;
          done(sg);
        })
        .catch(function () { sg.innerHTML = ''; done(sg); });
    }
    /* A single-variant card is picked by the card itself: there is no size to
       choose, so no panel. Same rules as a size button — a group that needs one
       swaps (or clears on a second click), a bigger group adds up to its count,
       and the summary steppers take it back down. */
    function pickCard(gid, card) {
      var id = parseInt(card.dataset.bdSingle, 10);
      if ((need[gid] || 0) === 1) {
        var already = findSel(gid, id);
        sel[gid] = [];
        if (already) { render(); return; }
      }
      addPick(gid, id, card.dataset.bdName, '',
        (card.dataset.bdInstockIds || '').split(',').indexOf(String(id)) !== -1,
        parseInt(card.dataset.bdPrice, 10) || 0,
        parseInt(card.dataset.bdCompare, 10) || 0);
    }

    function showPanel(gid, name) {
      var b = blocks[gid];
      if (b.panelName) b.panelName.textContent = b.shorten ? b.shorten(name) : name;
      if (b.panel) b.panel.hidden = false;
      b.cards.forEach(function (c) { c.classList.toggle('is-active', c.dataset.bdName === name); });
      buildSizeGroup(b, name, function () {
        var sgs = b.panel.querySelectorAll('[data-bd-sizegroup]');
        Array.prototype.forEach.call(sgs, function (sg) { sg.hidden = sg.dataset.bdName !== name; });
        render();
      });
    }
    function hidePanel(gid) {
      var b = blocks[gid];
      if (b.panel) b.panel.hidden = true;
      b.cards.forEach(function (c) { c.classList.remove('is-active'); });
    }

    function selectDeal(el, keepSel) {
      deals.forEach(function (d) { d.classList.remove('is-selected'); });
      el.classList.add('is-selected');
      deal = {
        index: el.dataset.bdIndex,
        items: JSON.parse(el.dataset.bdItems || '[]'),
        price: parseInt(el.dataset.bdPrice, 10) || 0,
        priceFmt: el.dataset.bdPriceFmt || ''
      };
      need = {};
      deal.items.forEach(function (it) { need[it.group] = (need[it.group] || 0) + it.qty; });
      sel = keepSel || {};
      /* show only the groups this deal needs; a group with nothing to choose
         is filled here and stays hidden, so the tier alone makes the deal */
      var stepNum = 2;
      groupBlocks.forEach(function (gb) {
        var gid = gb.dataset.bdGroup;
        var required = need[gid] || 0;
        var sole = required > 0 ? soleCard(gid) : null;
        if (sole) {
          var sid = parseInt(sole.dataset.bdSingle, 10);
          sel[gid] = [{ id: sid, name: sole.dataset.bdName, display: sole.dataset.bdName, size: '', qty: required,
            e48: (sole.dataset.bdInstockIds || '').split(',').indexOf(String(sid)) !== -1,
            price: parseInt(sole.dataset.bdPrice, 10) || 0, compare: parseInt(sole.dataset.bdCompare, 10) || 0, sole: true }];
        }
        gb.hidden = required === 0 || !!sole;
        if (!gb.hidden) {
          var numEl = gb.querySelector('.bundle-tiers__step-num');
          if (numEl) numEl.textContent = stepNum++;
        }
        if (blocks[gid].pill) blocks[gid].pill.textContent = pickText(required);
        hidePanel(gid);
      });
      /* Quantity is then the only step, so it needs no number. */
      if (step1Num) step1Num.style.display = stepNum === 2 ? 'none' : '';
      requestAnimationFrame(function () {
        Object.keys(blocks).forEach(function (gid) {
          var r = blocks[gid].el.querySelector('[data-bd-colors]');
          if (r && !blocks[gid].el.hidden) r.scrollLeft = 0;
        });
        updateScrollers();
      });
      render();

      /* Auto-select the current product's colour when its group needs exactly 1,
         so only size is left to pick (driven by the bundle's preselect setting).
         Skipped on an upsell (keepSel) — the shopper's picks are preserved. */
      if (currentHandle && !keepSel) {
        groupBlocks.forEach(function (gb) {
          if (gb.hidden) return;
          var gid = gb.dataset.bdGroup;
          if ((need[gid] || 0) !== 1) return;
          var b = blocks[gid];
          var card = (b.cards || []).filter(function (c) { return c.dataset.bdHandle === currentHandle; })[0];
          if (!card) return;
          if (card.dataset.bdSingle) pickCard(gid, card); else showPanel(gid, card.dataset.bdName);
        });
      }
    }

    function addPick(gid, id, name, size, is48, price, compare) {
      if (groupCount(gid) >= (need[gid] || 0)) return;
      sel[gid] = sel[gid] || [];
      var ex = findSel(gid, id);
      if (ex) ex.qty += 1; else sel[gid].push({ id: id, name: name, display: (blocks[gid].shorten ? blocks[gid].shorten(name) : name), size: size, qty: 1, e48: is48, price: price || 0, compare: compare || 0 });
      render();
    }

    function render() {
      Object.keys(blocks).forEach(function (gid) {
        var b = blocks[gid];
        var full = groupCount(gid) >= (need[gid] || 0);
        var byName = {}, byId = {};
        (sel[gid] || []).forEach(function (s) { byName[s.name] = (byName[s.name] || 0) + s.qty; byId[s.id] = (byId[s.id] || 0) + s.qty; });
        b.cards.forEach(function (card) {
          var n = byName[card.dataset.bdName] || 0;
          card.classList.toggle('has-chosen', n > 0);
          var c = card.querySelector('[data-bd-chosen]'); if (c) c.textContent = n > 0 ? '×' + n : '';
          card.classList.toggle('is-locked', full && n === 0);
        });
        var liveSizeBtns = b.panel ? b.panel.querySelectorAll('[data-bd-size]') : [];
        Array.prototype.forEach.call(liveSizeBtns, function (sb) {
          var n = byId[parseInt(sb.dataset.bdId, 10)] || 0;
          sb.classList.toggle('is-active-qb', n > 0);
          var cnt = sb.querySelector('[data-bd-count]'); if (cnt) cnt.textContent = n > 1 ? n : '';
        });
      });

      /* summary chips across all groups. The per-unit price (discounted unit
         + struck RRP) only appears once every option is chosen. */
      var dealFull = deal && allFull();
      var dealUnits = deal ? deal.items.reduce(function (n, it) { return n + it.qty; }, 0) : 0;
      var unitD = (dealFull && dealUnits) ? deal.price / dealUnits : 0;
      var chips = [];
      Object.keys(sel).forEach(function (gid) {
        var b = blocks[gid];
        (sel[gid] || []).forEach(function (s, i) {
          if (s.sole) return; /* shown by the tier card itself */
          var img = (b.img && b.img[s.name]) || '';
          var priceLine = '';
          if (dealFull && unitD > 0) {
            var cmp = b.unitCompare || 0;
            priceLine = '<span class="bundle-tiers__chip-price">' +
              (cmp > unitD ? '<s>' + money(cmp) + '</s> ' : '') +
              money(unitD) + ' / ' + perUnitLabel +
              '</span>';
          }
          chips.push(
            '<div class="bundle-tiers__chip">' +
              (img ? '<img class="bundle-tiers__chip-img" src="' + img + '" alt="" width="48" height="48" loading="lazy">' : '') +
              '<span class="bundle-tiers__chip-text"><span class="bundle-tiers__chip-color">' + (s.display || s.name) + '</span>' +
              '<span class="bundle-tiers__chip-meta">' + (s.size ? '<span class="bundle-tiers__chip-size">' + s.size + '</span>' : '') + badgeHtml(s.e48) + '</span>' +
              priceLine + '</span>' +
              '<span class="bundle-tiers__stepper">' +
                '<button type="button" class="bundle-tiers__stepper-btn" data-bd-dec="' + gid + ':' + i + '">−</button>' +
                '<span class="bundle-tiers__stepper-qty">' + s.qty + '</span>' +
                '<button type="button" class="bundle-tiers__stepper-btn" data-bd-inc="' + gid + ':' + i + '">+</button>' +
              '</span>' +
            '</div>'
          );
        });
      });
      if (summaryEl) { summaryEl.hidden = chips.length === 0; summaryEl.innerHTML = chips.join(''); }

      /* CTA + dynamic savings from chosen products */
      var full = deal && allFull();
      if (deal) {
        var regular = 0;
        /* Always value each unit at the group's highest compare-at, so the
           savings stay consistent regardless of which colour is picked. */
        Object.keys(sel).forEach(function (gid) { (sel[gid] || []).forEach(function (s) { regular += (blocks[gid].unitCompare || s.compare || s.price || blocks[gid].unit) * s.qty; }); });
        if (ctaPrice) ctaPrice.textContent = deal.priceFmt;
        if (ctaCompare) ctaCompare.textContent = regular > deal.price ? money(regular) : '';
      }
      var points = wrap.querySelector('sneak-points');
      if (points && points.setAmount) points.setAmount(deal ? deal.price : 0);
      var totalNeed = Object.keys(need).reduce(function (n, g) { return n + need[g]; }, 0);
      var totalHave = Object.keys(need).reduce(function (n, g) { return n + groupCount(g); }, 0);
      ctaBtn.disabled = !full;
      ctaLabel.textContent = full ? L.cta : pickText(totalHave + '/' + totalNeed);
      updateUpsell();
    }

    deals.forEach(function (d) { d.addEventListener('click', function () { upsold = false; selectDeal(d); }); });

    /* ── Tier upsell: nudge a single-group quantity tier up by one ──────── */
    function nextTierEl(items) {
      if (!items || items.length !== 1) return null; // only single-group tiers
      var g = items[0].group, q = items[0].qty;
      for (var i = 0; i < deals.length; i++) {
        var di = JSON.parse(deals[i].dataset.bdItems || '[]');
        if (di.length === 1 && di[0].group === g && di[0].qty === q + 1) return deals[i];
      }
      return null;
    }
    function updateUpsell() {
      if (!upsellBtn) return;
      var nxt = deal ? nextTierEl(deal.items) : null;
      var marginal = nxt ? ((parseInt(nxt.dataset.bdPrice, 10) || 0) - deal.price) : 0;
      /* Only nudge once the current tier is fully chosen, and a bigger one exists. */
      if (!nxt || marginal <= 0 || !allFull()) { upsellBtn.hidden = true; upsellBtn._target = null; return; }
      var nextItems = JSON.parse(nxt.dataset.bdItems || '[]');
      var g = (nextItems[0] || {}).group;
      var nextQty = (nextItems[0] || {}).qty || 0;
      var titleEl = g && blocks[g] && blocks[g].el.querySelector('.bundle-tiers__step-title');
      var garment = titleEl ? titleEl.textContent.trim().toLowerCase() : '';
      var plural = PLURAL_GARMENTS.indexOf(garment) !== -1;
      var ord = (plural ? ORDINALS_PL : ORDINALS)[String(nextQty)] || '';
      var article = ETT_GARMENTS.indexOf(garment) !== -1 ? ARTICLE_ETT : ARTICLE;
      var priceHtml = '<span class="bundle-deals__upsell-price">' + money(marginal) + '</span>';
      upsellBtn._target = nxt;
      if (upsellText) upsellText.innerHTML = L.addMore
        .replace('#ART#', article).replace('#ORD#', ord).replace('#GAR#', garment).replace('#PRICE#', priceHtml)
        .replace(/\s+/g, ' ').trim();
      upsellBtn.hidden = false;
    }
    if (upsellBtn) {
      upsellBtn.addEventListener('click', function () {
        var nxt = upsellBtn._target;
        if (!nxt) return;
        var upGroup = (JSON.parse(nxt.dataset.bdItems || '[]')[0] || {}).group;
        /* Move up a tier but KEEP the shopper's picks. selectDeal closes the
           panels, so re-open the size picker on the last-chosen colour — the
           extra slot is empty, ready for them to pick its size. */
        selectDeal(nxt, sel);
        upsold = true;
        var arr = (upGroup && sel[upGroup]) || [];
        var last = arr[arr.length - 1];
        var lastCard = last && blocks[upGroup].cards.filter(function (c) { return c.dataset.bdName === last.name; })[0];
        if (lastCard && !lastCard.dataset.bdSingle && !blocks[upGroup].el.hidden) showPanel(upGroup, last.name);
      });
    }

    wrap.addEventListener('click', function (e) {
      var close = e.target.closest('[data-bd-panel-close]');
      if (close) { var gb = close.closest('[data-bd-groupblock]'); hidePanel(gb.dataset.bdGroup); return; }

      var inc = e.target.closest('[data-bd-inc]');
      if (inc) { var p = inc.dataset.bdInc.split(':'); var gid = p[0]; if (groupCount(gid) < need[gid]) { sel[gid][p[1]].qty += 1; render(); } return; }
      var dec = e.target.closest('[data-bd-dec]');
      if (dec) { var q = dec.dataset.bdDec.split(':'); var g2 = q[0], idx = parseInt(q[1], 10); sel[g2][idx].qty -= 1; if (sel[g2][idx].qty <= 0) sel[g2].splice(idx, 1); render(); return; }

      var sizeBtn = e.target.closest('[data-bd-size]');
      if (sizeBtn) {
        if (sizeBtn.disabled) return;
        var sg = sizeBtn.closest('[data-bd-sizegroup]');
        var gid3 = sizeBtn.closest('[data-bd-groupblock]').dataset.bdGroup;
        var sizeId = parseInt(sizeBtn.dataset.bdId, 10);
        /* Single-pick groups behave like a radio: clicking a size switches to
           it (instead of being blocked once one is chosen); clicking the
           already-selected size clears it. Multi-pick groups keep the additive
           behaviour and use the summary steppers to adjust. */
        if ((need[gid3] || 0) === 1) {
          var already = findSel(gid3, sizeId);
          sel[gid3] = [];
          if (already) { render(); return; }
        }
        addPick(
          gid3,
          sizeId,
          sg.dataset.bdName,
          sizeBtn.dataset.bdSizeLabel,
          sizeBtn.dataset.bdInstock === '1',
          parseInt(sg.dataset.bdPrice, 10) || 0,
          parseInt(sg.dataset.bdCompare, 10) || 0
        );
        return;
      }

      var card = e.target.closest('[data-bd-card]');
      if (!card) return;
      var gid4 = card.closest('[data-bd-groupblock]').dataset.bdGroup;
      if (card.classList.contains('is-locked')) return;
      if (card.dataset.bdSingle) { pickCard(gid4, card); return; }
      if (card.classList.contains('is-active')) { hidePanel(gid4); return; }
      showPanel(gid4, card.dataset.bdName);
    });

    ctaBtn.addEventListener('click', function () {
      if (!deal || !allFull()) return;
      /* Stamp each line with which bundle/deal-instance/group it fills. The
         discount Function reads the actual PRICE from the shop metafield
         bundle_config_v2 (single source of truth) — never from a client value
         — and validates each line's price against the group's range. */
      var bundleId = wrap.dataset.bundleId || '';
      var lineId = (bundleId || 'bundle') + '-' + Date.now();
      var items = [];
      /* Variants picked without the in-stock/48h badge are preorders. They carry
         the preorder line-item property too (the cart reconciler checks every
         line again, this just gets it right from the first moment). It is merged
         into the props, so the _bundle_* keys the Function reads stay as they are. */
      var outOfStock = {};
      Object.keys(sel).forEach(function (gid) {
        var perVariant = {};
        (sel[gid] || []).forEach(function (s) {
          perVariant[s.id] = (perVariant[s.id] || 0) + s.qty;
          if (!s.e48) outOfStock[s.id] = true;
        });
        Object.keys(perVariant).forEach(function (id) {
          var props = {
            _bundle: 'true',
            _bundle_id: bundleId,
            _bundle_title: wrap.dataset.bundleName || '',
            _bundle_line: lineId,
            _bundle_group: gid
          };
          if (upsold) props._bundle_upsell = 'true';
          items.push({
            id: parseInt(id, 10),
            quantity: perVariant[id],
            properties: outOfStock[id] && window.sneakPreorder ? window.sneakPreorder.stampProps(props) : props
          });
        });
      });
      ctaBtn.disabled = true; ctaBtn.style.opacity = '0.6';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var drawer = document.getElementById('cart-drawer'); if (drawer && drawer.show) drawer.show();
          selectDeal(wrap.querySelector('[data-bd-deal].is-selected') || deals[0]);
        })
        .catch(function (err) { console.error('BundleDeals ATC error', err); })
        .finally(function () { ctaBtn.style.opacity = ''; });
    });

    var pre = wrap.querySelector('[data-bd-deal].is-selected') || deals[0];
    if (pre) selectDeal(pre);
    setTimeout(updateScrollers, 250);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else setTimeout(init, 100);
  /* Re-init after Section Rendering API swaps (injected scripts don't run);
     the wrap-level bdReady flag keeps this idempotent. */
  document.addEventListener('shopify:section:load', function () { setTimeout(init, 100); });
})();
